import app from '@/main'
import axios from 'axios'
import { detectOS } from '@/utils/utils'

const state = {
  classOption: [], // 班级下拉
  playGuide: false,
  os: detectOS(),
  bindPhone: {
    type: '', // rebind | bind
    status: false,
    token: '' // 修改手机需用到原手机验证token
  },
  isDouble: false, // 了解双师课堂
  serverTime: null // 服务器时间
}
// getters
const getters = {
  isWindow: state => {
    return ['Win7', 'Win8', 'Win10', 'WinXP'].includes(state.os)
  }
}

const actions = {
  // 获取班级下拉列表
  async getClassOption ({ commit, rootState }) {
    const unit_id = rootState.user.role_id
    if (unit_id === 40001) {
      const res = await API.get('/edu/zone/channel/agent/class/simple')
      if (res.status < 400) {
        commit('setClassOption', res.data)
      }
    } else {
      const res = await API.get('/edu/zone/classes/simple')
      if (res.status < 400) {
        commit('setClassOption', res.data)
      }
    }
  },
  // 跳转获取code
  async bcmEncode ({ commit }, playload) {
    try {
      return await API.post('/edu/zone/bcm/code/encode', playload)
    } catch (error) {
      return error
    }
  },
  // 数据加解密
  async phoneNumberDecode ({ commit }, payload) {
    const token = await app.$auth('get_access_token')
    const res = await axios({
      method: 'post',
      url: `${window.CONFIG.open_service}/decode/phone_number`,
      data: {
        cipher_text: payload
      },
      headers: {
        'Authorization': token,
        'Authorization-Type': '11'
      }
    })
    return res
  },
  // 获取服务器时间
  async getServerTime ({ commit }) {
    const res = await API.get('/edu/base/server/time')
    commit('setState', {
      module: 'base',
      key: 'serverTime',
      value: res.data.timestamp
    })
    return res
  }
}

const mutations = {
  setClassOption (state, data) {
    state.classOption = data
  },
  setOldPhoneToken (state, data) {
    state.bindPhone.token = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
